import {
  Text,
  Modal,
  Flex,
  ModalOverlay,
  ModalContent,
  ModalHeader,
  ModalFooter,
  ModalBody,
  ModalCloseButton,
} from "@chakra-ui/react";
import { formatDateOntemHoje } from "infra/helpers/formatDateOntemHoje";
import Button from "components/Button";
import { Box } from "@chakra-ui/layout";
import OutlineButton from "ui/components/Button/OutlineButton";
import { FaShare } from "react-icons/fa";
import colors from "core/resources/theme/colors";
import { Avatar } from "@chakra-ui/avatar";
import { MensagemItem } from "core/features/mensagens/typings";
import moment from "moment";
interface ModalProps {
  mensagem: Partial<MensagemItem>;
  onReply: () => void;
  isOpen: boolean;
  onClose: () => void;
}
export default function LerMensagemModal({
  isOpen,
  onClose,
  mensagem,
  onReply,
}: ModalProps) {
  return (
    <>
      <Modal size={"4xl"} isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />
        <ModalContent>
          <ModalHeader maxH={"75px !important"}>
            <Flex
              gridGap={3}
              pt={2}
              pb={4}
              w="100%"
              mb={4}
              borderBottomWidth={1}
              borderBottomColor={colors.black700}
            >
              <Avatar
                src={mensagem.imagemUrl || undefined}
                name={mensagem.autor}
                w="45px"
                h="45px"
              />
              <Flex flexDir="column" flexGrow={1}>
                <Text fontWeight="bold" fontSize={16}>
                  {mensagem.autor}
                </Text>
                <Text fontWeight="light" fontSize={13}>
                  {formatDateOntemHoje(mensagem.createdAt!)} às{" "}
                  {moment(mensagem.createdAt!).format("HH:mm")}
                </Text>
              </Flex>
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody px={10}>
            <Text
              maxH="50vh"
              overflow="auto"
              fontSize={13}
              my={2}
              className="custom-scroll-bar"
              dangerouslySetInnerHTML={{ __html: mensagem.conteudo || "" }}
            />
          </ModalBody>

          <ModalFooter>
            <Flex
              gridGap={4}
              w="fit-content"
              ml="auto"
              justify="baseline"
              align="baseline"
            >
              <Button size={"sm"} variant="outline" onClick={onClose}>
                Fechar
              </Button>
              <OutlineButton
                h="32px"
                py={0}
                fontSize={12}
                lineColor={colors.primary}
                ml="auto"
                mt={2}
                onClick={onReply}
              >
                <Box as="span" transform="scaleX(-1)" mr={2}>
                  <FaShare size={12} />
                </Box>
                Responder
              </OutlineButton>
            </Flex>
          </ModalFooter>
        </ModalContent>
      </Modal>
    </>
  );
}
